import { regionIdSelector } from 'shared/selectors/offerData/geo/regionIdSelector';
import { IState } from 'shared/store';

export const selectNewbuildingRentTrapUrl = (state: IState): string => {
  const regionId = regionIdSelector(state);

  return `/cat.php/?deal_type=sale&engine_version=2&from_developer=1&has_decoration=1&object_type%5B0%5D=2&offer_type=flat&region=${regionId}`;
};
